export class AreaUltimaModificacao {
  AreaId: number;
  AreaDescricao:string = "";
  UltimaAtualizacao: Date
}
